import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AuthorizedAppsAccessLayout } from 'pages/settings/pages/personal/pages/authorizedApps/layout/AuthorizedAppsAccessLayout'
import { AuthorizedAppsViewProvider } from 'pages/settings/pages/developer/pages/authorizedApps/context/authorizedAppsViewContext'
import { AuthorizedAppsPage } from 'pages/settings/pages/developer/pages/authorizedApps/ui/authorizedAppsPage'

export const AuthorizedAppsRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<AuthorizedAppsAccessLayout />}>
        <Route
          path='/'
          element={
            <AuthorizedAppsViewProvider>
              <AuthorizedAppsPage />
            </AuthorizedAppsViewProvider>
          }
        />
      </Route>
    </RoutesWithNotFound>
  )
}
